import React from "react";
import {
  Autocomplete,
  TextField,
  Box,
  Typography,
  Avatar,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import DefaultPhoto from "../../../assets/img-default.png";

const useStyle = makeStyles((theme) => ({
  autocomplete: {
    "& .MuiOutlinedInput-root": {
      backgroundColor: "#FFFFFF",
      border: "2px solid #D0D5DD",
      borderRadius: "4px",
      "&:hover": {
        borderColor: "#98A2B3",
      },
      "&.Mui-focused": {
        borderColor: theme.palette.primary.main,
      },
      "& fieldset": {
        border: "none",
      },
    },
    "& .MuiInputBase-input": {
      fontSize: "1rem",
      color: "rgba(0, 0, 0, 0.87)",
      "&::placeholder": {
        color: "#A4A6A8",
        opacity: 1,
      },
    },
  },
  option: {
    display: "flex",
    alignItems: "center",
    padding: "12px 16px", // More padding for better spacing
    minHeight: "60px", // Ensure consistent height
    backgroundColor: "#ffffff", // White background for better visibility
    "&:hover": {
      backgroundColor: "#ffffff",
    },
  },
  productPhoto: {
    width: 40, // Larger image
    height: 40,
    borderRadius: 4,
    marginRight: 12, // More spacing from text
  },
  paper: {
    maxHeight: "300px",
    width: "auto",
    minWidth: "300px",
    maxWidth: "100%",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
  },
}));

export default function ProductSelectComponent({
  selectedProduct,
  placeholder,
  productDropdown,
  isFetching,
  handleItemSearch,
  handleProductChange,
  isError,
}) {
  const classes = useStyle();

  return (
    <Autocomplete
      value={selectedProduct}
      onChange={(event, newValue) => {
        handleProductChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        if (handleItemSearch) {
          handleItemSearch(newInputValue);
        }
      }}
      options={productDropdown || []}
      getOptionLabel={(option) => option?.name || ""}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      loading={isFetching}
      loadingText="Loading products..."
      noOptionsText={isError ? "Error loading products" : "No products found"}
      className={classes.autocomplete}
      disablePortal
      PaperComponent={({ children, ...props }) => (
        <Box {...props} className={classes.paper}>
          {children}
        </Box>
      )}
      renderOption={(props, option) => (
        <Box component="li" {...props} className={classes.option}>
          <img
            src={option.picture || DefaultPhoto}
            alt="product"
            className={classes.productPhoto}
          />
          <Box flex={1}>
            <Typography
              variant="body1"
              style={{ fontWeight: 500, fontSize: "1.1rem" }}
            >
              {option.name}
            </Typography>
            {option.sku && (
              <Typography
                variant="body2"
                style={{
                  color: "#666",
                  fontSize: "0.9rem",
                  marginTop: "2px",
                }}
              >
                SKU: {option.sku}
              </Typography>
            )}
            {option.attributes && option.attributes.length > 0 && (
              <Typography
                variant="body2"
                style={{
                  color: "#666",
                  fontSize: "0.9rem",
                  marginTop: "2px",
                }}
              >
                Attributes : {option.attributes.join(", ")}
              </Typography>
            )}
          </Box>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          placeholder={placeholder || "Type to search products..."}
          fullWidth
        />
      )}
    />
  );
}
